module.exports = __webpack_public_path__ + "img/serifnew_box15.820584b2.jpg";